import React, { useEffect, useState } from "react";
import cl from "./EditStory.module.css";
import { StoryThumbnail } from "./Stories";
import axios from "axios";
import api from "../../../api";
import { accessGlobalUserState } from "../../../stores/user";

// img
// title
// payload
// type
// status

const STORY_TYPES = [
  { type: 1, name: "Ссылка на сайт" },
  {
    type: 2,
    name: "Ссылка внутри приложения",
  },
  {
    type: 3,
    name: "Без контента",
  },
];

const STORY_STATUSES = [
  {
    status: 1,
    name: "Включен",
  },
  {
    status: 2,
    name: "Выключен",
  },
];

const EditStory = () => {
  const [storySlide, setStorySlide] = useState([]);
  const [story_data, setStoryData] = useState({
    title: "",
    payload: "",
    type: "1",
    status: 1,
  });
  const [storyBreadcrumb, setStoryBreadcrumb] = useState(null);
  const userState = accessGlobalUserState().get();

  const handleFilesChange = (e) => {
    const files = e.target.files;
    const slides = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();
      reader.onloadend = () => {
        slides.push({ order: i, image: reader.result, file: file });
        if (slides.length === files.length) {
          setStorySlide(slides);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const sortStorySlides = (slides) => {
    return slides.sort((a, b) => a.order - b.order);
  };

  const saveStory = async () => {
    const formData = new FormData();
    formData.append("title", story_data.title);
    formData.append("payload", story_data.payload);
    formData.append("type", story_data.type);
    formData.append("status", story_data.status);
    formData.append("thumbnail", storyBreadcrumb);
    storySlide
      .sort((a, b) => a.order - b.order)
      .forEach((slide) => {
        formData.append("slides", slide.file);
      });
    try {
      const res = await axios.post(
        `${api.serverUrl}/admin/upload-story`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${userState.token}`,
          },
        }
      );
      if (res.status === 200) {
        console.log("Story saved successfully");
        alert("Story saved successfully");
        window.location.reload();
      } else {
        console.error("Error saving story:", res.data);
        alert("Error saving story");
      }
    } catch (error) {
      console.error("Error saving story:", error);
      alert("Error saving story");
    }
  };

  useEffect(() => {
    const sortedSlides = sortStorySlides(storySlide);
    setStorySlide(sortedSlides);
    console.log("Sorted slides:", sortedSlides);
  }, [storySlide]);

  return (
    <div className={cl.wrapper}>
      <div className={cl.breadcrumb}>
        <div
          className={cl.back}
          onClick={() => {
            window.history.back();
          }}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='feather feather-arrow-left'
          >
            <line x1='19' y1='12' x2='5' y2='12'></line>
            <polyline points='12 19 5 12 12 5'></polyline>
          </svg>
        </div>

        <div className={cl.breadcrumbText}>
          <span>Редактирование</span>
        </div>
      </div>
      <div className={cl.form}>
        <div className={cl.formGroup}>
          <label htmlFor='title'>Заголовок</label>
          <input
            type='text'
            onChange={(e) => {
              story_data.title = e.target.value;
            }}
            placeholder='Заголовок сторис'
            id='title'
          />
        </div>
        <div className={cl.formGroup}>
          <label htmlFor='title'>Картинка</label>
          {story_data?.breadcrumb ? (
            <img
              onClick={() => {
                document.getElementById("breadcrumbFile").click();
              }}
              src={story_data.breadcrumb}
              alt='Breadcrumb'
              className={cl.breadcrumbImage}
            />
          ) : (
            <label
              className={cl.breadcrumbInput}
              htmlFor='breadcrumbFile'
            ></label>
          )}
          <input
            type='file'
            id='breadcrumbFile'
            style={{ display: "none" }}
            onChange={(e) => {
              const file = e.target.files[0];
              setStoryBreadcrumb(file);
              const reader = new FileReader();
              reader.onloadend = () => {
                story_data.breadcrumb = reader.result;
                console.log("Breadcrumb image:", reader.result);
              };
              reader.readAsDataURL(file);
            }}
          />
        </div>
        <div className={cl.formGroup}>
          <label htmlFor='payload'>Сторисы</label>
          <div className={cl.stories}>
            <StoryThumbnail
              image={null}
              onclick={() => {}}
              edit={true}
              onFileChange={handleFilesChange}
            />
            {storySlide
              .sort((a, b) => a.order - b.order)
              .map((slide, index) => (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setStorySlide((prev) =>
                      prev.filter((c, i) => c.image !== slide.image)
                    );
                  }}
                  key={`${index}-slide`}
                >
                  <StoryThumbnail
                    image={slide.image}
                    onclick={() => {}}
                    edit={true}
                    localImage={true}
                    onFileChange={() => {}}
                  />
                </div>
              ))}
          </div>
        </div>
        <div className={cl.formGroup}>
          <label htmlFor='type'>Тип использования</label>
          <select
            id='type'
            onChange={(e) => {
              story_data.type = e.target.value;
            }}
          >
            {STORY_TYPES.map((type) => (
              <option key={type.type} value={type.type}>
                {type.name}
              </option>
            ))}
          </select>
        </div>
        <div className={cl.formGroup}>
          <label htmlFor='title'>Ссылка</label>
          <input
            type='text'
            onChange={(e) => {
              story_data.payload = e.target.value;
            }}
            placeholder='Ссылка на сайт или внутри приложения'
            id='title'
          />
        </div>
        <div className={cl.formGroup}>
          <label htmlFor='status'>Статус</label>
          <select
            id='status'
            onChange={(e) => {
              story_data.status = e.target.value;
            }}
          >
            {STORY_STATUSES.map((status) => (
              <option key={status.status} value={status.status}>
                {status.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className={cl.buttonGroup}>
        <button className={cl.deleteButton}>Удалить</button>
        <button className={cl.cancelButton}>Отменить</button>
        <button className={cl.saveButton} onClick={saveStory}>
          Сохранить
        </button>
      </div>
    </div>
  );
};

export default EditStory;
